// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useCallback } from 'react';
import FormDialog from '../../../components/Dialog/FormDialog';
import { useParties } from '../../../contexts/PartiesContext';
import { useRequestProviderService } from '../../../hooks/mutations/registry/onboarding/useRequestProviderService';

type DialogProps = {
  open: boolean;
  onClose: () => void;
};

export const RequestProviderServiceDialog = ({ open, onClose }: DialogProps) => {
  const requestProviderService = useRequestProviderService();
  const { operator, party } = useParties();

  const handleClose = useCallback(() => {
    onClose();
  }, [onClose]);

  const handleSubmit = useCallback(async () => {
    await requestProviderService({ argument: { operator, provider: party } });
    handleClose();
  }, [requestProviderService, handleClose, operator, party]);

  const isLoading = false;
  if (isLoading) return null;

  const disableSubmit = false;

  return (
    <FormDialog
      open={open}
      title="Request Provider Service"
      onCancel={handleClose}
      onSubmit={handleSubmit}
      submitName="Request"
      isSubmitDisabled={disableSubmit}
    />
  );
};
